import raf, { cancel as caf } from 'raf';

/* eslint-disable no-param-reassign */
function easeInOutCubic(t, b, c, d) {
  const ts = (t /= d) * t;
  const tc = ts * t;
  return b + c * (-2 * tc + 3 * ts);
}
/* eslint-enable no-param-reassign */

/**
 * Animate scroll to position
 * @param top - position (number)
 * @param options - (duration, offset, callback, easing)
 * @param container
 */
const animateScroll = (top, options = {}, container) => {
  const isScrollbar = !!container.getScrollTop;
  const start = container.getScrollTop();
  const opt = {
    duration: options.duration || 400,
    offset: options.offset || 0,
    callback: options.callback,
    onCancel: options.onCancel,
    easing: options.easing || easeInOutCubic,
    stopOnUserScroll:
      options.stopOnUserScroll === undefined ? true : options.stopOnUserScroll,
  };
  const distance = top - start;
  const duration =
    typeof opt.duration === 'function' ? opt.duration(distance) : opt.duration;
  let timeStart;
  let timeElapsed;
  let frameId;
  let initialFrameId;
  let cancelled;

  if (opt.stopOnUserScroll) {
    const el = isScrollbar ? container.view.current : container;

    const handleUserScroll = () => {
      el.removeEventListener('wheel', handleUserScroll);
      el.removeEventListener('touchmove', handleUserScroll);
      caf(frameId);
      caf(initialFrameId);
      cancelled = true;
      if (typeof opt.onCancel === 'function') opt.onCancel();
    };

    el.addEventListener('wheel', handleUserScroll);
    el.addEventListener('touchmove', handleUserScroll);
  }

  const scrollTop = (offset) => {
    container.scrollTop(offset);
  };

  const end = () => {
    const offset = start + distance;
    scrollTop(offset);
    if (typeof opt.callback === 'function') opt.callback();
  };

  const loop = (time) => {
    if (cancelled) return;

    timeElapsed = time - timeStart;
    const offset = opt.easing(timeElapsed, start, distance, duration);
    scrollTop(offset);
    if (timeElapsed < duration) {
      frameId = raf(loop);
      return;
    }
    end();
  };

  initialFrameId = raf((time) => {
    timeStart = time;
    loop(time, container);
  });
};

export default animateScroll;
